import { render, staticRenderFns } from "./formPemenuhanKewajiban.vue?vue&type=template&id=8fc02300&"
import script from "./formPemenuhanKewajiban.vue?vue&type=script&lang=js&"
export * from "./formPemenuhanKewajiban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports